import * as types from '../actiontypes';
import {API_RESOURCES, createApiReadAction} from '../../util/api';

export const getTrialBalance = (engagementId, queryString, includeArray) =>
	createApiReadAction(
		types.GET_TRIAL_BALANCE,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TRIAL_BALANCE]: null
		},
		queryString,
		{
			resolve: true,
			includeArray
		}
	);

export const getTrialBalanceById = (engagementId, trialBalanceId, queryString, includeArray, accountId) =>
	createApiReadAction(
		types.GET_TRIAL_BALANCE_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TRIAL_BALANCE]: trialBalanceId
		},
		queryString,
		{
			resolve: true,
			includeArray
		},
		undefined,
		undefined,
		undefined,
		{
			accountId: accountId
		}
	);
